import { lazy } from "react";

//lazy-loaded Layouts
const DashboardLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.DashboardLayout }))
);
const AuthLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.AuthLayout }))
);
const ProfileLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.ProfileLayout }))
);

// lazy-loaded Pages
const lazyLoad = (moduleName) =>
  lazy(() =>
    import("pages").then((module) => ({ default: module[moduleName] }))
  );

const Login = lazyLoad("Login");
const Dashboard = lazyLoad("Dashboard");
const AddressBook = lazyLoad("AddressBook");
const Guest = lazyLoad("Guest");
const CreateGuest = lazyLoad("CreateGuest")
const Reports = lazyLoad("Reports");
const Event = lazyLoad("Event");
const Floor = lazyLoad("Floor");
const Room = lazyLoad("Room");
const ApprovedBy = lazyLoad("ApprovedBy");
const RoomBook = lazyLoad("RoomBook");
const CreateRoomBooking = lazyLoad("CreateRoomBooking");
const KeyRequest = lazyLoad("KeyRequest");
const CreateKeyRequest = lazyLoad("CreateKeyRequest");
const Supervisor = lazyLoad("Supervisor");
const CreateSupervisor = lazyLoad("CreateSupervisor")
const Buyer = lazyLoad("Buyer");
const Category = lazyLoad("Category");
const Item = lazyLoad("Item");
const Purchase = lazyLoad("Purchase");
const AddPurchase = lazyLoad("AddPurchase");
const StockTransaction = lazyLoad("StockTransaction");
const AddStockTransaction = lazyLoad("AddStockTransaction");
const Challan = lazyLoad("Challan");
const AddChallan = lazyLoad("AddChallan");
const Shop = lazyLoad("Shop");
const AddShop = lazyLoad("AddShop");

// creating route objects
const createRoute = (path, element, isPrivate = false) => ({
  path,
  element,
  isPrivate,
});

export const routeConfigs = [
  {
    layout: AuthLayout,
    children: [
      createRoute("/", Login, false),
      createRoute("other", Login, false),
  
    ],
  },
  {
    layout: DashboardLayout,
    children: [
      createRoute("dashboard", Dashboard, true),
      createRoute("address_book", AddressBook, true),
      createRoute("guest", Guest, true),
      createRoute("guest/create", CreateGuest, true),
      createRoute("guest/edit/:id", CreateGuest, true),
      createRoute("guest/view/:id/:eventView", CreateGuest, true),
      createRoute("hotal_report", Reports, true),
      createRoute("master/event", Event, true),
      createRoute("master/floor", Floor, true),
      createRoute("master/room", Room, true),
      createRoute("master/approved_by", ApprovedBy, true),
      createRoute("store/buyer", Buyer, true),
      createRoute("store/category", Category, true),
      createRoute("store/item", Item, true),
      createRoute("store/purchase", Purchase, true),
      createRoute("stock/purchase/create", AddPurchase, true),
      createRoute("stock/purchase/edit/:id", AddPurchase, true),
      createRoute("stock/purchase/view/:id/:eventView", AddPurchase, true),
      createRoute("store/shop", Shop, true),
      createRoute("stock/shop/create", AddShop, true),
      createRoute("stock/shop/edit/:id", AddShop, true),
      createRoute("stock/shop/view/:id/:eventView", AddShop, true),
      createRoute("store/stock_transaction", StockTransaction, true),
      createRoute("store/stock_transaction/create", AddStockTransaction, true),
      createRoute("store/stock_transaction/edit/:id", AddStockTransaction, true),
      createRoute("store/stock_transaction/view/:id/:eventView", AddStockTransaction, true),
      createRoute("store/challan", Challan, true),
      createRoute("store/challan/create", AddChallan, true),
      createRoute("store/challan/edit/:id", AddChallan, true),
      createRoute("store/challan/view/:id/:eventView", AddChallan, true),
      createRoute("booking/room", RoomBook, true),
      createRoute("booking/room/create", CreateRoomBooking, true),
      createRoute("booking/room/edit/:id", CreateRoomBooking, true),
      createRoute("booking/room/view/:id/:eventView", CreateRoomBooking, true),
      createRoute("keyRequest", KeyRequest, true),
      createRoute("keyRequest/create", CreateKeyRequest, true),
      createRoute("keyRequest/edit/:id", CreateKeyRequest, true),
      createRoute("keyRequest/view/:id/:eventView", CreateKeyRequest, true),
      createRoute("supervisor", Supervisor, true),
      createRoute("supervisor/create", CreateSupervisor, true),
      createRoute("supervisor/edit/:id", CreateSupervisor, true),
      createRoute("supervisor/view/:id/:eventView", CreateSupervisor, true),
    ],
  },
  // {
  //   layout: ProfileLayout,
  //   children: [
  //     createRoute('register', Register, true),
  //     createRoute('profile', SelectCompany, true),
  //     createRoute('custom-table', Custom, true),
  //   ],
  // },
];
